import React, { useState } from "react";

function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      question: "What makes your web design services different?",
      answer:
        "Our company focuses on creating SEO-friendly, responsive, and conversion-focused websites tailored to each business’s unique goals.",
    },
    {
      question: "Why is responsive web design important?",
      answer:
        "Responsive web design ensures your website works smoothly across all devices, improving user experience and search engine rankings.",
    },
    {
      question: "How long does it take to design a website?",
      answer:
        "Project timelines depend on the website size and complexity. Basic websites may take a few weeks, while advanced projects may require more time.",
    },
    {
      question: "Do you offer UI/UX design services separately?",
      answer:
        "Yes, our professional ui ux design services are available for businesses looking to improve website usability and customer engagement.",
    },
    {
      question: "What industries do your web design services support?",
      answer:
        "Our web design services support businesses in healthcare, education, real estate, eCommerce, finance, technology, and more.",
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="k-faq-section">
      <div className="k-faq-container">
        <h2 className="k-faq-heading">Frequently Asked Questions</h2>

        {faqData.map((item, index) => (
          <div
            key={index}
            className={activeIndex === index ? "k-faq-box active" : "k-faq-box"}
          >
            <div className="k-faq-question" onClick={() => toggleFAQ(index)}>
              <span className="k-faq-title">{item.question}</span>
              <span className="k-faq-arrow">
                {activeIndex === index ? "▲" : "▼"}
              </span>
            </div>

            <div className="k-faq-answer">
              <p className="k-faq-text">{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default FAQ;
